import { render, staticRenderFns } from "./GatPopup.vue?vue&type=template&id=0047a6a7&scoped=true&"
import script from "./GatPopup.vue?vue&type=script&lang=js&"
export * from "./GatPopup.vue?vue&type=script&lang=js&"
import style0 from "./GatPopup.vue?vue&type=style&index=0&id=0047a6a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047a6a7",
  null
  
)

export default component.exports